export const netSuiteRequestFooterQa = 'netsuite-request-footer';
